import { SET_NOTIFS, SET_NOTIFS_LOADING, SET_NOTIFS_IMPORTANT } from './types'

// export const setNotifs = (notifs) => {
//     console.log('..masuk notifsAction')
//     return {
//         type : SET_NOTIFS,
//         payload : notifs
//     }
// }

export function getNotifs() {
    return (dispatch, getState) => {
        fetch('https://api.nasa.gov/DONKI/notifications?&type=report&api_key=qfu92Q3t1xBcZPHWCphiBhTZrqnB3KhQfsKNnbME')
        .then( response => response.json() )
        .then( data => {
          dispatch({
              type: SET_NOTIFS,
              payload: {
                  notifs: data
              }
          })
        })
        .catch(err => {
          console.log(err)
        })
    }
}

export const setNotifsLoading = (value) => {
    return {
        type : SET_NOTIFS_LOADING,
        payload : value
    }
}

export const setNotifsImportant = (item) => {
    return {
        type : SET_NOTIFS_IMPORTANT,
        payload : item
    }
}